import type { UpgradeRequirements, PersonnelBundle, ResourceBundle } from '@/types/EntityTypes';
import { GameState } from './GameState';
import { Entity } from './Entity';

export class PersonEntity extends Entity {

  constructor(params: {
    id: string;
    name: string;
    description: string;
    cost: number;
    storage?: ResourceBundle;
    consumes?: ResourceBundle;
    produces?: ResourceBundle;
    progressionRequirements?: UpgradeRequirements;
  }) {
    super(params);
  }

  override getDisplayText(): string {
    return `Hire ${this.name} ($${this.cost})`;
  }

  shouldLeave(gameState: GameState): boolean {
    return (gameState.resources.money || 0) < 0;
  }

  applyLeaving(gameState: any, stateProperty: string): void {
    // Reduce personnel count
    (gameState[stateProperty] as number)--;
  }

  getLeavingMessage(): string {
    return `👋 ${this.name} left due to non-payment!`;
  }

  getStatePropertyName(): keyof PersonnelBundle {
    return this.id as keyof PersonnelBundle;
  }

  static getAvailablePersons(persons: PersonEntity[], gameState: GameState): PersonEntity[] {
    return persons.filter(person => person.canBeBuilt(gameState));
  }
} 